import React, { Component } from 'react';

import SupportLoginForm from './SupportLoginForm';
import Logger, {LOG_LEVELS} from '../../utils/logger';
const log = new Logger('SUPPORT_LOGIN_PAGE', LOG_LEVELS.DEBUG);

class SupportLoginPage extends Component {
    render() {
        log.debug('render(): ', this.props, this);

        return (
            <div className="avalara-hero">
                <SupportLoginForm
                    onSuccessHandler={this.props.onSuccessHandler}
                    onFailHandler={this.props.onFailHandler}
                    history={this.props.history}
                />
            </div>
        )
    }
}


export default SupportLoginPage;